"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.getBookingViewPixel = getBookingViewPixel;
exports.getErrorViewPixel = getErrorViewPixel;
exports.getFSSFacilityViewPixel = getFSSFacilityViewPixel;
exports.getFacilityViewPixel = getFacilityViewPixel;
exports.getIndexViewPixel = getIndexViewPixel;
exports.getLandingViewPixel = getLandingViewPixel;
exports.getOutboundViewPixel = getOutboundViewPixel;
exports.getPSPLandingViewPixel = getPSPLandingViewPixel;
exports.getPaidLandingViewPixel = getPaidLandingViewPixel;
exports.getSearchLandingViewPixel = getSearchLandingViewPixel;
exports.getSearchViewPixel = getSearchViewPixel;
exports.getStaticViewPixel = getStaticViewPixel;
exports.getUnitViewPixel = getUnitViewPixel;

var _get = _interopRequireDefault(require("lodash/get"));

var _querystring = require("querystring");

function makeTrackingPixelSrc(type, params) {
  if (params === void 0) {
    params = {};
  }

  var query = (0, _querystring.stringify)(params);
  return "/pixel/type/" + type + (query ? "?" + query : '');
}

function getIndexViewPixel() {
  return makeTrackingPixelSrc('index');
}

function getStaticViewPixel() {
  return makeTrackingPixelSrc('static');
}

function getBookingViewPixel(confirmationCode) {
  return makeTrackingPixelSrc('confirmation', {
    cc: confirmationCode
  });
}

function getPaidLandingViewPixel(paidType) {
  return makeTrackingPixelSrc(paidType + "Paid");
}

function getPSPLandingViewPixel(pageType) {
  return makeTrackingPixelSrc(pageType + "PSP");
}

function getLandingViewPixel(_ref) {
  var _ref$result = _ref.result,
      result = _ref$result === void 0 ? {} : _ref$result,
      _ref$content = _ref.content,
      content = _ref$content === void 0 ? {} : _ref$content;
  return makeTrackingPixelSrc('siteContent', {
    searchId: (0, _get["default"])(result, 'searchId', ''),
    facilityIds: (0, _get["default"])(result, 'facilities', []).join(','),
    searchWeightId: -1,
    scid: (0, _get["default"])(content, 'contentId', '')
  });
}

function getErrorViewPixel(errorType) {
  return makeTrackingPixelSrc(errorType);
}

function getUnitViewPixel(unitId, facilityId) {
  return makeTrackingPixelSrc('unitConfirmation', {
    uid: unitId,
    fid: facilityId
  });
}

function getSearchViewPixel(_temp) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      _ref2$searchId = _ref2.searchId,
      searchId = _ref2$searchId === void 0 ? '' : _ref2$searchId,
      _ref2$facilities = _ref2.facilities,
      facilities = _ref2$facilities === void 0 ? [] : _ref2$facilities;

  return makeTrackingPixelSrc('search', {
    searchId: searchId,
    facilityIds: facilities.join(','),
    searchWeightId: -1
  });
}

function getSearchLandingViewPixel(search, content) {
  return makeTrackingPixelSrc('siteContent', {
    searchId: (0, _get["default"])(search, 'searchId', ''),
    facilityIds: (0, _get["default"])(search, 'facilities', []).join(','),
    searchWeightId: -1,
    scid: (0, _get["default"])(content, 'contentId', '')
  });
}

function getFacilityViewPixel(_ref3) {
  var facility = _ref3.facility;
  return makeTrackingPixelSrc('facilityDetail', {
    fid: facility
  });
}

function getFSSFacilityViewPixel(facilityId) {
  return makeTrackingPixelSrc('warehouseFacilityDetail', {
    fid: facilityId
  });
}

function getOutboundViewPixel(confirmationCode) {
  return makeTrackingPixelSrc('outbound', {
    cc: confirmationCode
  });
}